import { render, staticRenderFns } from "./StoreTemplate.vue?vue&type=template&id=6e89bd8c&"
import script from "./StoreTemplate.vue?vue&type=script&lang=ts&"
export * from "./StoreTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports